import { SwitchRef } from "@plasmicapp/react-web";
import * as React from "react";
// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import {
  DefaultSwitchProps,
  PlasmicSwitch,
} from "./wab/client/plasmic/plasmic_kit_page_settings/PlasmicSwitch";

interface SwitchProps extends DefaultSwitchProps {}

function Switch_(props: SwitchProps, ref: SwitchRef) {
  const { plasmicProps, state } = PlasmicSwitch.useBehavior<SwitchProps>(
    props,
    ref
  );
  return <PlasmicSwitch {...plasmicProps} />;
}

const Switch = React.forwardRef(Switch_);

export default Object.assign(Switch, {
  __plumeType: "switch",
});
